import React, { Component } from "react";
import RemovableBadge from "../../RemovableBadge";
/**
 * <Invitees editMode={} invitees={} removeInvitee={}
 *  toggleTrueFalse={} />
 * props:
 *  - Boolean editMode
 *  - Boolean selectingInvitees
 *  - Array<object>  invitees: [{user_id,rsvp,email,full_name}, {...}, ...]
 *  - function removeInvitee
 *  - function toggleTrueFalse
 **/
const Invitees = (props) => {
  const invitees = props.invitees.map((inv, i) => {
    return (
      <RemovableBadge
        key={"inv-" + i}
        label={inv["email"]}
        handleRemove={props.removeInvitee}
        stateKey="invitees"
        stateIndex={i}
        toDestroy={inv["_destroy"] === 1}
        editMode={props.editMode}
      />
    );
  });

  const addBtn = props.editMode ? (
    <button
      className={
        props.selectingInvitees
          ? "btn btn-danger pl-1 pr-1 pt-0 pb-0 mr-2"
          : "btn btn-primary pl-1 pr-1 pt-0 pb-0 mr-2"
      }
      title="View list of potential invitees"
      onClick={() => {
        props.toggleTrueFalse("selecting_invitees");
      }}
    >
      <strong>{props.selectingInvitees ? "x" : "+"}</strong>
    </button>
  ) : (
    ""
  );

  return (
    <div>
      {addBtn}
      <label>Invitees:</label>
      <div id="test-invitees" className="card p-3">
        {invitees}
      </div>
    </div>
  );
};

export default Invitees;
